// @ts-nocheck
import * as Types from '../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type FollowerFragment = { __typename?: 'InternalUser', id: string, name: string };

export const FollowerFragmentDoc = gql`
    fragment Follower on InternalUser {
  id
  name
}
    `;